import axios from "axios";
let BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "";

export default {
    state: {

    },
    getters: {

    },
    actions: {
      fetchAdminManagementOptions({}){
        return new Promise((resolve,reject) => {
          axios.get(`${BASE_URL}/auth/admin-management/options`).then((response) => {
            resolve(response.data.data)
          }).catch(error => {
            reject(error.response.data)
          })
        })
      },
      fetchAdminManagementAdmins({}){
        return new Promise((resolve,reject) => {
          axios.get(`${BASE_URL}/auth/admin-management/admins`).then((response) => {
            resolve(response.data.data)
          }).catch(error => {
            reject(error.response.data)
          })
        })
      },
      lookupAdminManagementUser({}, payload){
        return new Promise((resolve,reject) => {
          axios.post(`${BASE_URL}/auth/admin-management/lookup`, payload).then((response) => {
            resolve(response.data.data)
          }).catch(error => {
            reject(error.response.data)
          })
        })
      },
      updateAdminManagementCategory({}, payload){
        return new Promise((resolve,reject) => {
          axios.put(`${BASE_URL}/auth/admin-management/category`, payload).then((response) => {
            resolve(response.data)
          }).catch(error => {
            reject(error.response.data)
          })
        })
      },
      assignAdminManagementRole({}, payload){
        return new Promise((resolve,reject) => {
          axios.post(`${BASE_URL}/auth/admin-management/role`, payload).then((response) => {
            resolve(response.data)
          }).catch(error => {
            reject(error.response.data)
          })
        })
      },
      removeAdminManagementRole({}, payload){
        return new Promise((resolve,reject) => {
          axios.delete(`${BASE_URL}/auth/admin-management/role`, { data: payload }).then((response) => {
            resolve(response.data)
          }).catch(error => {
            reject(error.response.data)
          })
        })
      }
    },
    mutations: {

    },
};
